<template>
  <div id="api2Main" class="body" ref="body">
    <vue-snotify></vue-snotify>
    <div v-if="loadingLogin" class="m-3">
      <v-skeleton-loader
          type="card"
          class="mb-4"
      ></v-skeleton-loader>
      <v-skeleton-loader
          type="image"
      ></v-skeleton-loader>
    </div>
    <template v-else>
      <div class="modal-mask" v-show="showLogin" id="modalLogin">
      <div v-if="showLogin" class="login-img wow fadeIn animated" alt=""
           style="visibility: visible; animation-name: fadeIn;background:#fff;"><div v-if="companyLogo" class="center-div mt-5 company-logo" :style="{backgroundImage: 'url(' + companyLogo + ')'}"></div></div>
      <div class="centerBox">
        <div class="centerBox"
             name="bounceInDown"
             delay="0s"
             duration="1s"
             :offset="0"
             animateClass="animated"
             :begin="false"
        >
          <div class="center-vertical">
            <div class="center-content row">
              <div class="center-margin">
                <form v-if="customLoginPage.length < 2" v-on:submit.prevent="currentPage === 0 ? tryLogin(login,password) : currentPage === 1 ? tryRegister() : currentPage === 2 ? tryRestorePass() : currentPage === 3 ? createNewPass() : a=>a"
                      id="formLogin">
                  <div class="content-box modal-content">
                    <h3 class="content-box-header content-box-header-alt bg-default">
                                            <span class="icon-separator">
                                                <font-awesome-icon icon="cog"/>
                                            </span>
                      <span class="header-wrapper pb-1">
                                                {{ $t("message.members_area") }}
                                                <small v-if="currentPage === 0 || (registrationType === 3 && currentPage === 1) || currentPage === 4">{{$t("message.login_to_your_account")}}</small>
                                                <small v-else-if="(currentPage === 1 && registrationType!==3) || currentPage === 5">{{$t("message.registration")}}</small>
                                                <small v-else-if="(currentPage === -1)"><span class="loading"></span> {{$t("message.loading")}}...</small>
                                                <small v-else-if="(currentPage === 2)">{{$t("message.recovery_password")}}</small>
                                                <small v-else-if="(currentPage === 3)">{{$t("message.create_password")}}</small>
                                            </span>
                      <span class="header-buttons">
                                                  <a v-if="currentPage === 0 && showRegistrationPage" href=""
                                                     @click.prevent="currentPage = 1"
                                                     :disabled="isLoading"
                                                     class="btn btn-sm btn-primary" part="buttonRegistrationTop" title="">{{$t("message.registration")}}</a>
                                                  <a v-else-if="(currentPage === 1 && registrationType !== 3) || currentPage === 5" href=""
                                                     :disabled="isLoading || loadingRegistration"
                                                     @click.prevent="currentPage = 0" part="buttonSignInTop" class="btn btn-sm btn-primary"
                                                     title="">{{$t("message.sign_in")}}</a>
                                                  <a v-else-if="currentPage === 2" part="buttonSignInTop" href="" :disabled="isLoading"
                                                     @click.prevent="currentPage = 0" class="btn btn-sm btn-primary"
                                                     title="">{{$t("message.sign_in")}}</a>
                                            </span>
                    </h3>
                    <!--                                        Login-->
                    <div class="content-box-wrapper" v-if="currentPage === 0">
                      <div class="form-group">
                        <div class="input-group">
                          <input v-bind:type="loginValidation === 'email' ? 'email' : 'text'"
                                 class="form-control" id="login"
                                 v-model="login"
                                 v-bind:placeholder='loginValidation === "email" ? $t("message.enter_email") : $t("message.enter_login")'>
                          <span class="input-group-addon bg-blue">
                                                             <font-awesome-icon
                                                                 v-bind:icon="loginValidation === 'email' ? 'envelope' : 'user'"
                                                                 class="faw"/>
                                                    </span>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="input-group">
                          <input type="password" class="form-control"
                                 id="password"
                                 v-model="password"
                                 v-bind:placeholder='$t("message.password")'>

                          <span class="input-group-addon bg-blue">
                                                                <font-awesome-icon icon="unlock-alt" class="faw"/>
                            <!--<i class="glyph-icon icon-unlock-alt"></i>-->
                                                    </span>
                        </div>
                      </div>
                      <div class="form-group">
                        <a href="" title="Recover password" class="recover-password"
                           @click.prevent="currentPage=2">{{$t("message.forgot_your_password")}}</a>
                      </div>
                      <button id="buttonLogin" part="buttonLogin" type="submit" class="btn btn-success btn-block"
                              :disabled="isLoading"><span v-if="isLoading" class="loading"></span>
                        <span class="mr-1" v-if="!isLoading"><font-awesome-icon
                            icon="sign-in-alt" class="faw"/></span><span
                            v-if="!isLoading">{{ $t("message.sign_in") }}</span>
                      </button>
                      <div class="alert alert-danger" role="alert" v-if="isLoadingBad">
                        <font-awesome-icon class="fawExc" icon="exclamation-circle"/>
                        {{loginErrorMessage}}
                      </div>
                    </div>
                    <!--                                        Register-->
                    <div class="content-box-wrapper"
                         v-else-if="currentPage === 1 && showRegistrationPage">
                      <div class="form-group">
                        <label for="lf-ref"
                               class="control-label">{{$t('message.sponsor_id')}}
                          <span v-if="!enrollWithoutSponsor" style="color: red"> *</span>
                        </label>
                        <input id="lf-ref" class="form-control"
                               @keypress="isNumber"
                               pattern="\d+?"
                               maxlength="20"
                               :required="(!enrollWithoutSponsor || (sponsorIdRequiredMessage === 'on' && !hideSponsorsCheckbox && !canWithoutSponsor)) ? true : false"
                               type="text"
                               v-model="currentRefId"
                               :disabled="refId"
                               v-bind:placeholder="`${$t('message.enter') + ' ' + $t('message.sponsor_id')}`"
                               style="display: block;border-radius: 3px">
                        <div class="sponsorFullname" v-if="refId && sponsorName">{{sponsorName}}</div>
                      </div>
                      <div style="padding-bottom: 10px;"  v-if="sponsorIdRequiredMessage === 'on' && !hideSponsorsCheckbox">
                        <b-form-group class="payment-method mt-4">
                          <b-form-checkbox v-model="canWithoutSponsor" >
                            {{$t('message.dont_know_sponsor')}}
                          </b-form-checkbox>
                        </b-form-group>
                      </div>
                      <div v-if="!registrationParams" class="mb-3" style="text-align: center">
                        <span class="loading"></span>
                      </div>
                      <template v-else>
                        <div class="form-group" v-for="(oneCol) in registrationParams"
                             :key="oneCol.id">
                          <div>
                            <label v-bind:for="`lf-${oneCol.id}`" class="control-label">{{oneCol.title}}<span
                                v-if="oneCol.isMandatory"
                                style="color: red"> *</span></label>
                            <input class="form-control" v-bind:id="`lf-${oneCol.id}`"
                                   v-if="'email'===oneCol.alias"
                                   type="email"
                                   v-bind:placeholder="`${$t('message.enter') + ' ' + oneCol.title}`"
                                   v-model="oneCol.value"
                                   v-bind:required="oneCol.isMandatory"/>
                            <b-form-select
                                v-bind:style="oneCol.value==null? 'color:#999' : 'color:#333'"
                                v-bind:id="`lf-${oneCol.id}`"
                                v-else-if="'country_id'===oneCol.alias"
                                class="form-control" v-model="oneCol.value"
                                v-bind:required="oneCol.isMandatory"
                                @change="currentRegion.value = null">
                              <option :value="null">{{$t('message.please_select')}}
                                {{oneCol.title}}
                              </option>
                              <option v-for="oneCR in countryRegionList" :value="oneCR"
                                      :key="oneCR.id">
                                {{oneCR.title}}
                              </option>
                            </b-form-select>
                            <b-form-select
                                :disabled="!(currentCountry.value && currentCountry.value.regions && currentCountry.value.regions.length)"
                                v-bind:style="oneCol.value==null? 'color:#999' : 'color:#333'"
                                v-bind:id="`lf-${oneCol.id}`"
                                v-else-if="'region_id'===oneCol.alias"
                                class="form-control" v-model="oneCol.value"
                                v-bind:required="oneCol.isMandatory">
                              <option :value="null">{{$t('message.please_select')}}
                                {{oneCol.title}}
                              </option>
                              <option v-for="oneR in (currentCountry.value ? currentCountry.value.regions : [])"
                                      :value="oneR" :key="oneR.id">{{oneR.title}}
                              </option>
                            </b-form-select>
                            <div class="input-group bootstrap-touchspin"
                                 v-else-if="'numeric'===oneCol.fieldType.alias">
                                                        <span class="input-group-addon bootstrap-touchspin-prefix"
                                                              style="display: none;"></span>
                              <input v-bind:id="`lf-${oneCol.id}`" class="form-control"
                                     @keypress="isNumber"
                                     maxlength="20" v-bind:required="oneCol.isMandatory"
                                     type="text" v-bind:name="`nm-${oneCol.id}`"
                                     v-model="oneCol.value"
                                     v-bind:placeholder="`${$t('message.enter') + ' ' + oneCol.title}`"
                                     style="display: block;border-radius: 3px"><span
                                class="input-group-addon bootstrap-touchspin-postfix"
                                style="display: none;"></span><span
                                class="input-group-btn-vertical"><button
                                class="btn btn-default bootstrap-touchspin-up"
                                type="button"
                                @click="!isNaN(oneCol.value) ? oneCol.value++ : oneCol.value=0"><font-awesome-icon
                                style="height: 10px;position: absolute;left: 11px;top: 3px;"
                                icon="plus"/></button><button
                                class="btn btn-default bootstrap-touchspin-down"
                                type="button"
                                @click="!isNaN(oneCol.value)&&oneCol.value>0 ? oneCol.value--:oneCol.value=0"><font-awesome-icon
                                icon="minus"
                                style="height: 10px;position: absolute;left: 11px;top: 3px;"/></button></span>
                            </div>
                            <div v-else-if="'date'===oneCol.fieldType.alias">
                              <v-app v-bind:id="`lf-app-${oneCol.id}`">
                                <mlm-popover trigger="click"
                                             :options="{placement: 'auto'}"
                                             :ref="`mlm-p-${oneCol.id}`">
                                  <div slot="body">
                                    <v-date-picker header-color="#3f51b5"
                                                   color="green lighten-1"
                                                   v-bind:id="`lf-dp-${oneCol.id}`"
                                                   @input="$refs[`mlm-p-${oneCol.id}`][0].doClose()"
                                                   v-model="oneCol.value"></v-date-picker>
                                  </div>


                                  <div class="input-prepend input-group"
                                       slot="reference">
                                                                            <span class="add-on input-group-addon"
                                                                                  v-on:click.stop>
                                                                                <font-awesome-icon
                                                                                    icon="calendar-alt"
                                                                                    style="height: 16px;"/>
                                                                            </span>
                                    <input type="text"
                                           class="form-control input-date" readonly
                                           v-bind:style="{borderRightWidth: oneCol.value ? '0' : '1px'}"
                                           v-bind:required="oneCol.isMandatory"
                                           v-model="oneCol.value"
                                           v-bind:id="`lf-${oneCol.id}`">
                                    <span class="add-on input-group-addon clear-date"
                                          v-show="oneCol.value"
                                          v-on:click.stop="oneCol.value=null">
                                                                                <font-awesome-icon
                                                                                    icon="times"
                                                                                    style="height: 16px;"/>
                                                                            </span>
                                  </div>
                                </mlm-popover>
                              </v-app>
                            </div>

                            <div v-else-if="['float','currency'].includes(oneCol.fieldType.alias)"
                                 class="input-group bootstrap-touchspin"><span
                                class="input-group-btn"><button
                                class="btn btn-default bootstrap-touchspin-down"
                                type="button"
                                @click="!isNaN(oneCol.value)&&oneCol.value>0 ? oneCol.value=(oneCol.value-1).toFixed(8):oneCol.value=0"><font-awesome-icon
                                style="height: 11px" icon="minus"/></button></span><span
                                class="input-group-addon bootstrap-touchspin-prefix"
                                style="display: none;"></span><input
                                class="form-control"
                                v-bind:required="oneCol.isMandatory"
                                v-bind:id="`lf-${oneCol.id}`"
                                v-bind:placeholder="`${$t('message.enter') + ' ' + oneCol.title}`"
                                pattern="\d+(\.\d{1,})?"
                                type="text"
                                v-model="oneCol.value"
                                @keydown="processInputFloat"
                                style="display: block;"><span
                                class="input-group-btn"><button
                                class="btn btn-default bootstrap-touchspin-up"
                                type="button"
                                @click="!isNaN(oneCol.value) ? oneCol.value=(Number(oneCol.value) + 1).toFixed(8) : oneCol.value=0"><font-awesome-icon
                                style="height: 11px" icon="plus"/></button></span></div>
                            <b-form-select
                                v-bind:style="oneCol.value==null? 'color:#999' : 'color:#333'"
                                v-bind:id="`lf-${oneCol.id}`"
                                v-else-if="'dictionary'===oneCol.fieldType.alias"
                                class="form-control" v-model="oneCol.value"
                                v-bind:required="oneCol.isMandatory">
                              <option :value="null">{{$t('message.please_select')}}
                                {{oneCol.title}}
                              </option>
                              <option v-for="oneCR in oneCol.dictionary.items"
                                      :value="oneCR.key"
                                      :key="oneCR.key">
                                {{oneCR.value}}
                              </option>
                            </b-form-select>
                            <input class="form-control" v-bind:id="`lf-${oneCol.id}`"
                                   v-else type="text"
                                   v-bind:placeholder="`${$t('message.enter') + ' ' + oneCol.title}`"
                                   v-model="oneCol.value"
                                   v-bind:required="oneCol.isMandatory"/>
                          </div>
                        </div>
                        <template v-if="registrationMethod === 1">
                          <div class="form-group">
                            <label for="password1_reg">{{$t('message.password')}}</label>
                            <div class="button-inside">
                              <input class="form-control" id="password1_reg"
                                     v-model="password1"
                                     :type="showPass1 ? 'text' : 'password'" required
                                     :minlength="passwordLength||6">
                              <div class="button-pass"
                                   @click.prevent="showPass1=!showPass1">
                                <font-awesome-icon
                                    :icon="showPass1 ? 'eye' : 'eye-slash'"
                                    class="faw"/>
                              </div>
                            </div>
                          </div>
                          <div class="form-group">
                            <label for="password2_reg">{{$t('message.password_confirm')}}</label>
                            <div class="button-inside">
                              <input class="form-control" id="password2_reg"
                                     v-model="password2"
                                     :type="showPass2 ? 'text' : 'password'" required
                                     :minlength="passwordLength||6"
                                     v-bind:style="((p1L>(passwordLength-1||5)) && (password1===password2)) ? {'border-color': 'green'}: ((p2L>(passwordLength-1||5)) ? {'border-color': 'red'} : {}) ">
                              <div class="button-pass"
                                   @click.prevent="showPass2=!showPass2">
                                <font-awesome-icon
                                    :icon="showPass2 ? 'eye' : 'eye-slash'"
                                    class="faw"/>
                              </div>
                            </div>
                          </div>
                        </template>
                      </template>
                      <button id="buttonRegister" part="buttonRegister" type="submit" class="btn btn-success btn-block"
                              :disabled="isLoading || loadingRegistration"><span v-if="isLoading"
                                                                                 class="loading"></span>
                        <span class="mr-1" v-if="!isLoading"><font-awesome-icon
                            icon="sign-in-alt" class="faw"/></span><span
                            v-if="!isLoading">{{ $t("message.register") }}</span>
                      </button>
                      <div v-html="regHtml"></div>
                    </div>
                    <!--                                        After registration -->
                    <div class="content-box-wrapper" v-else-if="currentPage === 5">
                      <div class="registration-after-text">
                        <strong>{{ $t('message.user_created') }}</strong>
                        <br />
                        {{ this.registrationMethod === 1 ? $t("message.you_login") : $t("message.check_email_after_registration") }}
                      </div>
                    </div>
                    <!--                                        Forgot pass-->
                    <div class="content-box-wrapper" v-else-if="currentPage === 2">
                      <div class="form-group">
                        <div class="input-group">
                          <input type="email" class="form-control" id="login_recovery"
                                 v-model="email" required
                                 v-bind:placeholder='$t("message.enter_email")'>

                          <span class="input-group-addon bg-blue">
                                                             <font-awesome-icon icon="envelope" class="faw"/>
                                                    </span>
                        </div>
                      </div>
                      <button id="buttonRecovery" part="buttonLogin" type="submit" class="btn btn-success btn-block"
                              :disabled="isLoading"><span v-if="isLoading" class="loading"></span>
                        <span class="mr-1" v-if="!isLoading"><font-awesome-icon
                            icon="sign-in-alt" class="faw"/></span><span
                            v-if="!isLoading">{{ $t("message.email_new_password") }}</span>
                      </button>
                    </div>
                    <!--                                        NewPass-->
                    <div class="content-box-wrapper" v-else-if="currentPage === 3">
                      <div class="form-group">
                        <label for="password1">{{$t('message.password')}}</label>
                        <div class="button-inside">
                          <input class="form-control" id="password1" v-model="password1"
                                 :type="showPass1 ? 'text' : 'password'" required
                                 :minlength="passwordLength||6">
                          <div class="button-pass" @click.prevent="showPass1=!showPass1">
                            <font-awesome-icon :icon="showPass1 ? 'eye' : 'eye-slash'"
                                               class="faw"/>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <label for="password2">{{$t('message.password_confirm')}}</label>
                        <div class="button-inside">
                          <input class="form-control" id="password2" v-model="password2"
                                 :type="showPass2 ? 'text' : 'password'" required
                                 :minlength="passwordLength||6"
                                 v-bind:style="((p1L>(passwordLength-1||5)) && (password1===password2)) ? {'border-color': 'green'}: ((p2L>(passwordLength-1||5)) ? {'border-color': 'red'} : {}) ">
                          <div class="button-pass" @click.prevent="showPass2=!showPass2">
                            <font-awesome-icon :icon="showPass2 ? 'eye' : 'eye-slash'"
                                               class="faw"/>
                          </div>
                        </div>
                      </div>
                      <button id="buttonConfirmPass" type="submit"
                              class="btn btn-success btn-block"
                              :disabled="isLoading || (password1!==password2 && p1L>(passwordLength-1||5) && p2L>(passwordLength-1||5))">
                        <span v-if="isLoading" class="loading"></span>
                        <span class="mr-1" v-if="!isLoading"><font-awesome-icon
                            icon="sign-in-alt" class="faw"/></span><span
                          v-if="!isLoading">{{ $t("message.sign_in") }}</span>
                      </button>
                    </div>
                    <!--                                        disable access-->
                    <div class="content-box-wrapper" v-else-if="currentPage === 4">
                      <div class="form-group">
                        <strong>{{disableAccess}}</strong>
                      </div>
                    </div>
                    <b-dropdown :text="getLanguageDescription(locale)" ref="fff"
                                v-if="getAllLanguages.length>1"
                                variant="outline-primary" lazy>
                      <template v-if="freezeLocale">
                        <b-dropdown-item v-for="(lang) in getAllLanguages" v-bind:key="lang"
                                         v-bind:href="hrefLang(lang)">
                          {{getLanguageDescription(lang)}}
                        </b-dropdown-item>
                      </template>
                      <template v-else>
                        <b-dropdown-item v-for="(lang) in getAllLanguages" v-bind:key="lang"
                                         @click="setLanguage(lang)">
                          {{getLanguageDescription(lang)}}
                        </b-dropdown-item>
                      </template>
                    </b-dropdown>
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
    </template>
  </div>
</template>

<script>
import mlmPopover from '../../nested_components/mlm_popover/Popover'
import {VDatePicker, VApp} from 'vuetify/lib'
import {BDropdownItem, BFormSelect, BFormCheckbox} from 'bootstrap-vue'
import {VSkeletonLoader} from 'vuetify/lib'
import BDropdown from '../../nested_components/bootstrap-vue/BDropdown'
import MLMSoftUICore from './MLMSoftUICore'
// noinspection SpellCheckingInspection
import Snotify from 'vue-snotify'
import Vuetify from 'vuetify/lib'
// noinspection ES6CheckImport
// import {UAnimateContainer, UAnimate} from 'vue-wow'
import {library} from '@fortawesome/fontawesome-svg-core'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import {
  faTimes,
  faCog,
  faEnvelope,
  faUnlockAlt,
  faSpinner,
  faExclamationCircle,
  faSignInAlt,
  faEye,
  faEyeSlash,
  faCalendarAlt,
  faUser
} from '@fortawesome/free-solid-svg-icons' //icon-cog, icon-envelope-o,icon-unlock-alt
library.add(faCog, faEnvelope, faUnlockAlt, faSpinner, faExclamationCircle, faSignInAlt, faEye, faEyeSlash, faCalendarAlt, faTimes, faUser);
if (!window.Vue.$_vuetify_installed)
  window.Vue.use(Vuetify);
const sUi = MLMSoftUICore.instance;
const store = sUi.getStore();
const HTTPGlobalSettings = store.dispatch('request', {
  path: 'api2/main-app/setting/get-list?group=global',
  method: 'get',
  withoutCheckLogin: true,
});
const HTTPGlobalSettingsEnroll = store.dispatch('request', {
  path: 'api2/main-app/setting/get-list?group=enroll',
  method: 'get',
  withoutCheckLogin: true,
});
const i18n = new window.VueI18n({
  locale: 'en-US', // set locale
  fallbackLocale: 'en-US',
  messages: {
    "en-US": {
      "message": {
        "sign_in": "Sign In",
        "forgot_your_password": "Forgot Your Password?",
        "login_to_your_account": "Login to your account.",
        "enter_email": "Enter email",
        "password": "Password",
        "members_area": "MEMBERS AREA",
        "invalid_username_or_password": "Invalid username or password",
        "registration": "Registration",
        "loading": "Loading",
        "enter": "Enter",
        "sponsor_id": "Sponsor ID",
        "register": "Register",
        "recovery_password": "Recovery password",
        "email_new_password": "E-Mail new password",
        "user_creation_error": "User creation error",
        "user_created": "User created",
        "error": "Error",
        "try_to_login": "Try to login and repeat request",
        "check_email": "Please check email to registration complete",
        "cant_create_user": "Can't create a user",
        "account_not_found": "Account not found with such referral code",
        "warning": "Warning",
        "create_password": "Create password",
        "password_confirm": "Confirm password",
        "password_created": "Password created",
        "cant_find_email": "Can't find email or email is incorrect",
        "you_login": "You can sign in using your new login and password",
        "enter_login": "Enter login",
        "please_select": "Please select",
        "check_email_after_registration": "Confirmation email is sent. Make sure you check your email spam and junk folders.",
        "mail_confirmed": "Mail confirmed",
        "mail_already_confirmed": "E-mail already confirmed",
        "wrong_confirmation_code": "Wrong confirmation code",
        "dont_know_sponsor": "I don't know sponsor ID ",
        "user_exist": "User already exist",
        "unknown_sponsor_id": "Unknown sponsor ID"
      }
    },
  }

});
const keyCodes = {
  windows: {
    "backspace": 8,
    "tab": 9,
    "enter": 13,
    "left arrow": 37,
    "right arrow": 39,
    "delete": 46,
    "period": 190,
    "0": 48,
    "9": 57,
    "num 0": 96,
    "num 9": 105,
    "num period": 110,
    "input busy": 229
  }
};
const languageDescriptins = new Map([['en-us', 'English'], ['ru-ru', 'Русский'], ['bg-bg', 'Български'], ['es', 'Español'], ['fr', 'Français'], ['de-de', 'Deutsch']]);
//let listener = sUi.setListenerToLocale('Api2Middleware', i18n);
export default {
  name: 'api2-middleware',
  components: {
    VDatePicker,
    FontAwesomeIcon,
    VSkeletonLoader,
    // UAnimateContainer,
    // UAnimate,
    BDropdownItem,
    BDropdown,
    BFormSelect,
    BFormCheckbox,
    VApp,
    mlmPopover
  },
  vuetify: new Vuetify({
    icons: {
      iconfont: 'mdiSvg' // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4'
    }
  }),
  i18n: i18n,
  mixins: [Snotify],
  props: {
    customLoginPage: {
      type: String,
      default: '',
      required: false
    },
    customRegistrationPage: {
      type: String,
      default: '',
      required: false
    },
    registrationHtml: {
      type: String,
      default: ''
    },
    companyLogo: {
      type: String,
      default: ''
    },
    customLocalization: {
      type: String,
      default: ''
    },
    disableAccess: {
      type: String,
      default: ''
    },
    loginValidation: {
      type: String,
      default: 'email'
    },
    fontFamilyRe: {
      type: String,
      default: null,
      required: false
    },
    registerBackground: {
      type: String,
      default: null,
      required: false
    },
    registerBackgroundImg: {
      type: String,
      default: null,
      required: false
    },
    registrationType: { //0-open 1-referral 2-close
      required: false,
      default: 0,
      type: Number
    },
    allLanguages: {
      required: false,
      default: '["en-US","ru-RU"]',
      type: String
    },
    feedGroupNumber: {
      required: false,
      type: String
    },
    feedUrl: {
      required: false,
      type: String
    },
    xDomain: {
      required: false,
      type: String
    },
    thousandDelimeter: {
      default: ',',
      required: false,
      type: String
    },
    defaultLocalization: {
      default: 'en-US',
      required: false,
      type: String
    },
    freezeLocale: {
      default: false,
      required: false,
      type: Boolean
    },
    passwordLength: {
      default: 6,
      required: false,
      type: Number
    },
    accountTemplates: {
      default: '[]',
      required: false,
      type: String
    },
    registrationFields: {
      default: '[]',
      required: false,
      type: String
    },
    setOnRegister: {
      default: '[]',
      required: false,
      type: String
    },
    accountMask: {
      default: '0000 0000 0000',
      required: false,
      type: String
    },
    firstCountry: {
      required: false,
      type: String
    },
    sponsorIdRequiredMessage: {
      required: false,
      type: String,
      default: 'none'
    },
  },
  data: function () {
    return {
      hideSponsorsCheckbox: false,
      loadingLogin: true,
      sponsorName: null,
      country_and_regionRequired: false,
      xd_cookie: null,
      currentPage: 0,
      isLoading: false,
      loadingRegistration: false,
      refId: null,
      currentRefId: null,
      isLoadingBad: false,
      email: '',
      login: '',
      password: '',
      loginBackImg: '',
      countryRegionList: [],
      currentCountry: null,
      currentRegion: null,
      registrationParams: null,
      // setOnRegister_: null,
      password1: '',
      password2: '',
      showPass1: false,
      showPass2: false,
      registrationMethod: null, //0 - auto 1 - by user
      enrollWithoutSponsor: false,
      loginType: null,
      hideLogin: false,
      resetPassCodeConfirm: '',
      loginErrorMessage: '',
      canWithoutSponsor: false
    }
  },
  created: async function () {
    store.commit('localeFromStorage', {
      defaultLocale: this.defaultLocalization || 'en-US',
      freezeLocale: this.freezeLocale
    });

    if (localStorage.getItem("page") !== null) {
      const currentPageFromStorage = parseInt(sessionStorage.getItem('page'));
      const registrationsTypeFromStorage = parseInt(sessionStorage.getItem('regtype'));
      if (currentPageFromStorage !== null && !isNaN(currentPageFromStorage) && currentPageFromStorage != undefined) {
        if (currentPageFromStorage === 1) {
          this.registrationType = registrationsTypeFromStorage
        }
        this.currentPage = currentPageFromStorage
      }
      sessionStorage.removeItem('page');
      sessionStorage.removeItem('regtype');
    }

    if (this.fontFamilyRe)
      store.commit('setFontFamilyRe', this.fontFamilyRe);
    if (this.feedUrl)
      store.commit('setFeedUrl', this.feedUrl || '');
    if (this.feedGroupNumber != null)
      store.commit('setFeedGroupNumber', this.feedGroupNumber || 0);
    // noinspection JSUnresolvedVariable
    // this.xd_cookie = (!(/Safari/i.test(navigator.userAgent))) && (this.xDomain && window.xDomainCookie) ? window.xDomainCookie(this.xDomain, "my.namespace", true, undefined, true) : null;
    this.xd_cookie = (this.xDomain && window.xDomainCookie) ? window.xDomainCookie(this.xDomain, "my.namespace", true, undefined, true) : null;
    if (this.xd_cookie) {
      const t = localStorage.getItem('user-token');
      const rt = localStorage.getItem('user-refresh-token');
      const getCookiesPromise = new Promise((resolve, reject) => {
        this.xd_cookie.get('tkns', function (cookie_val) {
          // cookie val will contain value of cookie as fetched from local val (if present) else from iframe (if set), else null
          try {
            if (!cookie_val) {
              if (t && rt)
                store.commit('setTokensToStorage', {
                  accessToken: null,
                  refreshToken: null
                });
            } else {
              const cookie_val_obj = JSON.parse(cookie_val);
              if(localStorage.getItem('logout') !== '1') {
                store.commit('setTokensToStorage', {
                  accessToken: cookie_val_obj.ut,
                  refreshToken: cookie_val_obj.urt
                });
                store.commit('setIsLoggedIn', true);
              }
            }
            resolve();
          } catch (e) {
            reject(e);
          }

        });
      });
      await getCookiesPromise;
      localStorage.setItem('logout', '0');
    }
    try {
      let hashString = window.top.location.hash
      
      if(hashString.length > 0) {
        hashString.replace('#', '');
        let hashArr = hashString.split(';')
        if(hashArr.length === 4) {
          if(hashArr[0].length > 3 && hashArr[1].length > 3 && hashArr[1].length > 3 && hashArr[1].length > 3) {
            store.commit('setTokensToStorage', {
              accessToken: hashArr[0],
              refreshToken: hashArr[1]
            });
            store.commit('setApi3TokensToStorage', {
              accessToken: hashArr[2],
              refreshToken: hashArr[3]
            });
            store.commit('setIsLoggedIn', true);
            store.commit('setIsLoggedInApi3', true);
          }
        }
      }
    } catch (e) {
      console.log(e)
    }

    store.commit('getTokensFromStorage');
    // store.commit('getApi3TokensFromStorage');
    const fullPath = new URL(window.location.href);
    if(this.customLoginPage.length > 2) {
      if(!store.state.isLoggedIn) {
        let p = this.customLoginPage + '?redirect=' + window.location.pathname
        window.location = p
      }
      // if(!localStorage.getItem('accessTokenApi3')) {
      //   let p = this.customLoginPage + '?redirect=' + window.location.pathname
      //   window.location = p
      // }
    } else {
      this.loadingLogin = false
    }
    if(store.state.isLoggedIn) {
      this.loadingLogin = false
    }
    this.postCreate();
    const email_code_confirm = fullPath.searchParams.get('email_code_confirm');

    const ref = fullPath.searchParams.get('ref');
    if(ref?.length > 0 && this.customLoginPage.length > 1 && this.customRegistrationPage.length > 1 ) {
      window.location.replace(this.customRegistrationPage + '?ref=' + ref)
    }

    if(email_code_confirm) {
      await this.checkEmailConfirmation()
    }
    const page_flag = fullPath.searchParams.get('page');
    if(page_flag === 'registration') {
      this.registrationType = 0
      this.currentPage = 1
    }
  },
  computed: {
    regHtml() {
      if (!this.registrationHtml)
        return '';
      try {
        const parsedRH = JSON.parse(this.registrationHtml);
        if (Array.isArray(parsedRH)) {
          const foundItem = parsedRH.find(item => {
            const si = item.split('=');
            if (si.length<2)
              return false;
            return si[0].toString().trim().toLowerCase() === this.locale.toLowerCase();
          })
          if (foundItem)
            return foundItem.split('=').slice(1).join('=').trim();
          return '';
        }
      } catch (e) {
        console.error(e);
      }
      return '';
    },
    showRegistrationPage() {
      return this.registrationType === 0 || (this.refId != null && this.registrationType <= 1);
    },
    getAllLanguages() {
      let at;
      try {
        at = JSON.parse(this.allLanguages);
        if (!Array.isArray(at))
          at = [];
      } catch (e) {
        at = ['en-US'];
      }
      return at;
    },
    hrefEn() {
      return window.location.href.replace(/en-us/ig, 'ru-RU');
    },
    p1L() {
      return this.password1.length;
    },
    p2L() {
      return this.password2.length;
    },
    showLogin() {
      return !store.state.isLoggedIn;
    },
    locale() {
      return store.state.locale;
    },
    tokensSSO() {
      return store.getters.tokensSSO;
    }
  },
  watch: {
    refId(newValue) {
      if (!newValue) {
        this.sponsorName = null;
        return;
      }
      const that = this;
      store.dispatch('request', {
        path: 'api2/main-app/account/get-fullname-from-id?id=' + this.refId,
        method: 'get',
        withoutCheckLogin: true
      }).then(response => {
        if (!that.refId)
          throw 'refId is nulled';
        if (response.data.errorCode === 0) {
          const list = response['data']['primary']['payload']['list'];
          if (!list)
            throw 'list is null';
          that.sponsorName = list[that.refId]['p.'].firstname.value + ' ' + list[that.refId]['p.'].lastname.value;
        }}).
      catch( function () {
        that.sponsorName = null;
      })
    },
    tokensSSO(newValue) {
      if (!this.xd_cookie)
        return;
      if (newValue && newValue.accessToken && newValue.refreshToken)
        this.xd_cookie.set('tkns', JSON.stringify({
          "ut": newValue.accessToken,
          "urt": newValue.refreshToken
        }));
      else this.xd_cookie.set('tkns', 'false');
    },
    showLogin(newValue) {
      if (newValue) {
        window.dispatchEvent(new CustomEvent('showLoginForm'));
        if (this.loginValidation === 'id')
          this.idFromStorage();
        //this.getCredentialsFromCode();
        this.toggleBodyClass('addClass', 'modal-open');
        if (this.xd_cookie)
          this.xd_cookie.set('tkns', 'false');
      } else {
        window.dispatchEvent(new CustomEvent('hideLoginForm'));
        if (this.loginValidation === 'id')
          this.idToStorage();
        this.toggleBodyClass('removeClass', 'modal-open');
      }
    },
    locale(newLocale) {
      i18n.locale = newLocale;
      this.$vuetify.lang.current = newLocale;
    },
    currentPage(newValue) {
      if ((newValue === 1) && (!this.registrationParams))
        this.getRegistrationFields();
    }
  },
  methods: {
    idToStorage() {
      store.dispatch('getAccountId').then(aid => localStorage.setItem('IdLogin', aid || '')).catch(() => localStorage.removeItem('IdLogin'))
    },
    idFromStorage() {
      this.login = localStorage.getItem('IdLogin' || '')
    },
    getLanguageDescription(lang) {
      return languageDescriptins.get(lang.toLowerCase()) || lang;
    },
    hrefLang(lang) {
      sessionStorage.setItem('page', this.currentPage.toString())
      sessionStorage.setItem('regtype', this.registrationType.toString())

      const re = new RegExp(this.getAllLanguages.join('|'), 'ig');
      return window.location.href.replace(re, lang);
    },
    postCreate() {
      if (this.disableAccess != null && this.disableAccess.trim()){
        this.currentPage = 4;
        store.dispatch('logout');
      }
      store.dispatch('getLocalizationModule', {module: 'Api2Middleware', i18n: i18n, customLocalization: this.customLocalization});
      store.commit('setToastFunction', this.showToast);
      let at;
      try {
        at = JSON.parse(this.accountTemplates);
        if (!Array.isArray(at))
          at = [];
      } catch (e) {
        at = [];
      }
      at.length && store.commit('setAccountTemplate', at);
      MLMSoftUICore.setThousandDelimeter(this.thousandDelimeter);
      MLMSoftUICore.setAccountMask(this.accountMask);
      window.MLMSoftUICore = MLMSoftUICore;
      store.commit('setPaymentStackFromStorage');
      window.dispatchEvent(new CustomEvent('singletonCreated'));
      this.loginBackImg = this.registerBackgroundImg;
      if (!this.registerBackgroundImg && !this.registerBackground)
        this.loginBackImg = store.state.loginBackImg;
      this.getPayResultFromCode();
      this.getCredentialsFromCode(!this.showLogin)
    },
    toggleBodyClass(addRemoveClass, className) {
      this.$nextTick(() => {
        const el = document.body;

        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      });

    },
    //get sponsor id from ref code in path /?ref=code
    async getSponsorFromRef() {
      if (this.registrationType === 2)
        return false;
      try {
        const fullPath = new URL(window.location.href);
        const ref = fullPath.searchParams.get('ref');
        //get refId from refCode
        if (!ref)
          return false;
        this.currentPage = -1;
        await store.dispatch('request', {
          path: 'api2/main-app/account/search-by-invite?inviteCode=' + encodeURIComponent(ref),
          method: 'get',
          withoutCheckLogin: true
        }).then(response => {
          if (response.data.errorCode === 0) {
            const refAccount = response['data']['primary']['payload']['account'];
            if (!refAccount)
              throw this.$t('message.account_not_found');
            this.refId = refAccount.id;
            this.currentRefId = this.refId;
            this.hideSponsorsCheckbox = true;
          } else
            throw response.data.errorMessage;
        }).catch(e => {
          throw e;
        });
        this.currentPage = 1;
      } catch (e) {
        store.dispatch('showToast', {
          title: this.$t('message.warning'),
          body: (e && e.response && e.response.data && (typeof e.response.data === 'string')) ? e.response.data : this.$t('message.account_not_found'),
          type: 'warning',
          timeout: 7000
        });
        this.currentPage = 1;
      }
    },

    async checkEmailConfirmation() {

      const fullPath = new URL(window.location.href);
      const emailConfirmationCode = fullPath.searchParams.get('email_code_confirm');
      if (!emailConfirmationCode)
        return false;
      await store.dispatch('request', {
        path: 'api2/main-app/user/mail-confirm',
        method: 'post',
        params_: {
          "code": encodeURIComponent(emailConfirmationCode),
        },
        withoutCheckLogin: true
      }).then(response => {
        if (response.data.errorCode === 0) {
          const checkEmailCodeResult = response['data']['primary']['success'];
          if (checkEmailCodeResult) {
            store.dispatch('showToast', {
              title: this.$t('message.mail_confirmed'),
              body: this.$t('message.mail_confirmed'),
              type: 'success',
              timeout: 7000
            });
          }
        }
      }).catch(e => {
        if(e.response.data.errorCode === 3601) {
          store.dispatch('showToast', {
            title: this.$t('message.warning'),
            body: this.$t('message.mail_already_confirmed'),
            type: 'error',
            timeout: 7000
          });
        }
        if(e.response.data.errorCode === 3600) {
          store.dispatch('showToast', {
            title: this.$t('message.warning'),
            body: this.$t('message.wrong_confirmation_code'),
            type: 'error',
            timeout: 7000
          });
        }
      });
    },

    getPayResultFromCode() {
      const fullPath = new URL(window.location.href);
      const payId = fullPath.searchParams.get('checkPay');
      if (payId)
        store.dispatch('payResult', payId);
    },

    getCredentialsFromCode(onlyConfirm = false) {
      try {
        const fullPath = new URL(window.location.href);
        const code_confirm = fullPath.searchParams.get('code_confirm');

        if (!code_confirm) {
          if (onlyConfirm)
            return false;
          this.getSponsorFromRef();
          return false;
        }
        if (!onlyConfirm)
          this.currentPage = -1;
        HTTPGlobalSettings.then(response => {
          if (response.data.errorCode === 0) {
            try {
              this.registrationMethod = response['data']['primary']['payload']['settings']['passwordCreationType'];
              if (onlyConfirm && !this.registrationMethod)
                return false
              this.loginType = response['data']['primary']['payload']['settings']['loginType'];


              store.dispatch('request', {
                path: 'api2/main-app/user/mail-confirm',
                method: 'post',
                params_: {
                  "code": encodeURIComponent(code_confirm),
                  "setConfirmed": false
                },
                withoutCheckLogin: true
              }).then(() => {
                  this.currentPage = 3;
              }).catch(e => {
                store.dispatch('showToast', {
                  title: 'mail',
                  body: e.response.data.errorMessage,
                  type: 'error',
                  timeout: 7000
                });
                this.isLoading = false;
                this.currentPage = 0;
              });
            } catch (e) {
              if (!onlyConfirm){
                this.currentPage = 1;
                this.registrationMethod = 0;
                this.loginType = 1;
              }
            }
          } else {
            if (!onlyConfirm){
              this.currentPage = 1;
              this.registrationMethod = 0;
              this.loginType = 1;
            }
          }
        }).catch(function () {
              if (!onlyConfirm){
                this.currentPage = 1;
                this.registrationMethod = 0;
                this.loginType = 1;
              }
            }
        );
      } catch (e) {
        this.currentPage = 1;
      }
    },

    async getRegistrationFields() {
      this.loadingRegistration = true;
      let at;
      try {
        at = JSON.parse(this.registrationFields);
        if (!Array.isArray(at))
          at = [];
      } catch (e) {
        at = [];
      }
      if (at.includes('region_id') && !at.includes('country_id'))
        at.push('country_id');
      await HTTPGlobalSettings.then(response => {
        if (response.data.errorCode === 0) {
          try {
            this.registrationMethod = response['data']['primary']['payload']['settings']['passwordCreationType'];
            this.loginType = response['data']['primary']['payload']['settings']['loginType'];
          } catch (e) {
            this.registrationMethod = 0;
            this.loginType = 1;
          }
        } else {
          this.registrationMethod = 0;
          this.loginType = 1;
        }
      }).catch(function () {
            this.registrationMethod = 0;
            this.loginType = 1;
          }
      );
      await HTTPGlobalSettingsEnroll.then(response => {
        if (response.data.errorCode === 0) {
          try {
            this.enrollWithoutSponsor = response['data']['primary']['payload']['settings']['enrollWithoutSponsor'];
          } catch (e) {
            this.enrollWithoutSponsor = false;
          }
        } else {
          this.enrollWithoutSponsor = false;
        }
      }).catch(function () {
            this.enrollWithoutSponsor = false;
          }
      );
      const HTTP = store.dispatch('request', {
        path: 'api2/main-app/profile-field/get-list',
        method: 'get',
        withoutCheckLogin: true
      });
      HTTP.then(response => {
        if (response.data.errorCode === 0) {
          let allParams = (response['data']['primary']['payload']['list'].map(v => {
            if (v.fieldType.alias === 'dictionary') {
              v.value = null;
              v.dictionary.items.sort((a, b) => {
                return a.priority != null && (b.priority == null || a.priority < b.priority) ? -1 : b.priority != null && (a.priority == null || a.priority > b.priority) ? 1 : 0;
              });
              return v;
            }
            if (['country_id', 'region_id'].includes(v.alias)) {
              if (v.isMandatory)
                this.country_and_regionRequired = true;
              v.value = null;
              if ('country_id' === v.alias)
                this.currentCountry = v;
              else
                this.currentRegion = v;
            } else
              v.value = "";
            return v;
          }));
          if (at.includes('country_id') || this.country_and_regionRequired) {
            const isRegionAllowed = (at.includes('region_id') || this.country_and_regionRequired) ? 1 : 0;
            store.dispatch('request', {
              path: 'api2/main-app/country/get-list?withRegions=' + isRegionAllowed,
              method: 'get',
              withoutCheckLogin: true
            }).then(response => {
              if (response !== 'loading') {
                if (response.data.errorCode === 0) {
                  this.countryRegionList = response['data']['primary']['payload']['list'];
                  // Set first country to select
                  if(this.firstCountry !== '') {
                    let tempCountryArr = this.countryRegionList.find(item => item.title.trim() === this.firstCountry.trim())
                    let tempCountryFullArr = this.countryRegionList
                    if(tempCountryArr) {
                      tempCountryFullArr = tempCountryFullArr.filter(item => item.title.trim() !== this.firstCountry.trim())
                      tempCountryFullArr.unshift(tempCountryArr)
                      this.countryRegionList = tempCountryFullArr
                    }
                  }
                }
              }
            }).catch(e => {
              throw e;
            });
          }
          if (this.loginType < 3 && allParams.filter(value => value.isMandatory && value.alias === 'login').length) {//means 1,2 email id
            this.hideLogin = true;
            allParams = allParams.filter(value => {
              return value.alias !== 'login'
            });
          }
          allParams = allParams.filter(value => {
            return value.alias!=='country_and_region' && (value.isMandatory || at.includes(value.alias))
          });
          allParams.sort((a, b) => {
            return ((at.indexOf(a.alias) < 0 && at.indexOf(b.alias) >= 0) || (at.indexOf(a.alias) > at.indexOf(b.alias))) ? 1 : (at.indexOf(a.alias) < at.indexOf(b.alias)) ? -1 : 0;
          });
          this.registrationParams = allParams;
          this.loadingRegistration = false;
        }
      }).catch(() => {
        this.loadingRegistration = false;
      })
    },

    showToast: function (title, body, type, timeout) {
      if(timeout === undefined) {
        timeout = 2000
      }
      this.$snotify.create({title: title, body: body, config: {type: type, titleMaxLength: 100, timeout: timeout }});
    },

    tryLogin: function (m, p) {
      if (this.loginValidation === 'id')
        m = Math.abs(parseInt(m.toString().replace(/\s/g, ''))).toString();
      this.isLoading = true;
      store.dispatch('login', {m: m, p: p}).then(response => {
        this.isLoading = false;
        if (response !== 'ok') {
          this.isLoadingBad = true;
          this.loginErrorMessage = this.$t('message.invalid_username_or_password');
          setTimeout(() => {
            this.isLoadingBad = false
          }, 4000);
        } else {
          this.$emit('loginDone');
        }
      });
    },

    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && charCode < 48) || charCode > 57)
        evt.preventDefault();

    },

    processInputFloat(e) {
      let pressedKey = e.which,
          point = e.target.value.indexOf("."),
          keys = keyCodes.windows;

      // HACK for Chrome on Android (doesn't seem to work, though)
      if (pressedKey === keys["input busy"]) {
        e.preventDefault();
        return;
      }

      let allowedKeys = [
        keys["backspace"],
        keys["tab"],
        keys["enter"],
        keys["left arrow"],
        keys["right arrow"],
        keys["delete"],
        keys["period"],
        keys["num period"]
      ];

      // Decimal point already in value
      if (point !== -1) {
        allowedKeys.splice(allowedKeys.indexOf(keys["period"]), 1);
        allowedKeys.splice(allowedKeys.indexOf(keys["num period"]), 1);

        if (e.target.value.length > (point + 8) && this.selectionStart === this.selectionEnd &&
            (!allowedKeys.includes(pressedKey))) {
          // Allow only 2 decimal places, allow whitelisted keys after 2 decimal places reached
          e.preventDefault();
          return;
        }
      }

      if ((pressedKey < keys["0"] || pressedKey > keys["9"]) &&
          (pressedKey < keys["num 0"] || pressedKey > keys["num 9"]) &&
          (!allowedKeys.includes(pressedKey))) {
        // Allow only whitelisted (non-numeric) keys
        e.preventDefault();
      }
    },

    async afterPassCreate() {
      let st;
      try {
        st = JSON.parse(this.setOnRegister);
        if (!Array.isArray(st))
          st = [];
      } catch (e) {
        st = [];
      }
      if (st.length)
        st = st.map(a => a.toString().split('=', 2));

      function objectify(array) {
        return array.reduce(function (p, c) {
          p[c[0]] = c[1];
          return p;
        }, {});
      }

      st = objectify(st);
      if (Object.keys(st).length === 0)
        return false;
      //get account id
      let aid = await store.dispatch('getAccountId');
      //check already exists param values
      store.dispatch('getAccountInfo', {
        ids: [aid],
        properties: Object.keys(st)
      }).then(response => {
        Object.keys(st).forEach(a => (response.get(`${aid}.${a}`)['obj_val']['value']) || a.toString().length < 3 || st[a] == null || !(/^m\./i.test(a)) ? delete st[a] : false);
        let data = [];
        Object.keys(st).forEach(a => {
          data.push({
            "accountId": aid,
            "pointsAmount": st[a],
            "volumePropertyAlias": a.substring(2).toString()
          });
        });
        if (data.length)
          store.dispatch('request', {
            path: 'api2/main-app/account/volume-change',
            method: 'post',
            params_: {
              "data": data
            }
          })


      })
    },

    async createNewPass() {
      this.isLoading = true;
      const fullPath = new URL(window.location.href);
      const code_confirm = fullPath.searchParams.get('code_confirm');
      if(code_confirm) {
        HTTPGlobalSettings.then(response => {
          if (response.data.errorCode === 0) {
            try {
              store.dispatch('loginCode', {c: code_confirm}).then(() => {

                store.dispatch('requestFromNewAccount', {
                  path: 'api2/main-app/user/set-password',
                  method: 'post',
                  params_: {
                    "newPassword": this.password1
                  }
                }).then((response) => {
                      if (response.data.primary.success) {
                        store.dispatch('moveNewTokensToStorage');
                        this.isLoading = false;
                        this.currentPage = 0;
                        store.dispatch('showToast', {
                          title: this.$t('message.create_password'),
                          body: this.$t('message.password_created'),
                          type: 'success',
                          timeout: 5000
                        });
                        this.afterPassCreate();
                      } else {
                        this.isLoading = false;
                        store.dispatch('showToast', {
                          title: this.$t('message.create_password'),
                          body: (response.data.errorMessage && (typeof response.data.errorMessage === 'string')) ? response.data.errorMessage : this.$t('message.error'),
                          type: 'error',
                          timeout: 5000
                        });
                      }

                    }
                ).catch(e => {
                  this.isLoading = false;
                  store.dispatch('showToast', {
                    title: this.$t('message.create_password'),
                    body: (e && e.response && e.response.data && e.response.data.errorMessage && (typeof e.response.data.errorMessage === 'string')) ? e.response.data.errorMessage : this.$t('message.error'),
                    type: 'error',
                    timeout: 5000
                  });

                })

              }).catch(e => {
                console.log('e', e)
              });
            } catch (e) {
              console.log('e', e)
            }
          }
        })
      }

    },

    loginAfterRegister(m, p, t) {
      if (this.loginValidation === 'id')
        m = Math.abs(parseInt(m.toString().replace(/\s/g, ''))).toString();
      store.dispatch('loginAfter', {m: m, p: p, t: t}).then(response => {
        // if (response !== 'ok') {
        //     this.currentPage = 0;
        // }
        // else
        if (response === 'ok')
          this.afterPassCreate();
        this.currentPage = 0;

      });
    },
    async tryRegister() {
      if (this.registrationMethod === 1 && this.password1 !== this.password2 && this.p1L > (this.passwordLength - 1 || 5) && this.p2L > (this.passwordLength - 1 || 5))
        return;
      this.isLoading = true;
      let loginParam = "", typeParam = "member";
      let profileFields = {};
      let loginTypeAlias;
      switch (this.loginType) {
        case 1:
          loginTypeAlias = "email";
          break;
        case 2:
          loginTypeAlias = "id";
          break;
        case 3:
          loginTypeAlias = "login";
          break;
        default:
          loginTypeAlias = "email";

      }
      this.registrationParams.forEach(v => {
        if (v.alias === loginTypeAlias)
          loginParam = v.value;
        if (!v.value)
          return true;
        if (["country_id", "region_id"].includes(v.alias) && v.value.id) {
          profileFields[v.alias] = v.value.id;
          return true;
        }
        profileFields[v.alias] = v.value;
      });
      if (this.hideLogin)
        profileFields['login'] = loginParam;
      if (this.country_and_regionRequired) {
        profileFields['country_and_region']=this.currentCountry.value.id+'/'+this.currentRegion.value.id;
      }
      let createParams = {}
      if (profileFields.email && profileFields.email.length > 0) {
        createParams = {
          //"login": loginParam,
          "login": this.loginType === 2 ? '1' : loginParam,
          "password": this.registrationMethod === 1 ? this.password1 : null,
          "type": typeParam,
          "sponsorId": this.currentRefId,
          "profile": profileFields,
          "confirmationUrl": window.location.protocol + "//" + window.location.host + "/?email_code_confirm={{code}}"
        }
      } else {
        createParams = {
          //"login": loginParam,
          "login": this.loginType === 2 ? '1' : loginParam,
          "password": this.registrationMethod === 1 ? this.password1 : null,
          "type": typeParam,
          "sponsorId": this.currentRefId,
          "profile": profileFields,
        }
      }
      store.dispatch('request', {
        path: 'api2/main-app/user/create',
        method: 'post',
        params_: createParams,
        withoutCheckLogin: true
      }).then((response) => {
            if (response === 'loading') {
              this.isLoading = false;
              store.dispatch('showToast', {
                title: this.$t('message.error'),
                body: this.$t('message.try_to_login'),
                type: 'error',
                timeout: 5000
              });
            } else {
              this.isLoading = false;
              if (this.registrationMethod === 1){
                this.currentPage = -1;
                const that = this;
                if (this.loginType === 2) {
                  try {
                    loginParam = response.data.primary.payload.auth.login;
                  }
                  catch (e) {
                    loginParam = '';
                  }
                }
                setTimeout(function () {
                  that.loginAfterRegister(loginParam, that.password1, response.data.primary.payload.proxyAuthToken)
                }, 5000);
              } else {
                this.currentPage = 5;
              }

            }
          }
      ).catch(e => {
        this.isLoading = false;

        let v1 = 'Can not auth';
        let v2 = 'User already exists';
        let v3 = 'Sponsor account with';


        let errMessage = e.response.data.errorMessage;
        if(errMessage.includes(v1)) {
          errMessage = this.$t('message.user_creation_error')
        }
        if(errMessage.includes(v2)) {
          errMessage = this.$t('message.user_exist')
        }
        if(errMessage.includes(v3)) {
          errMessage = this.$t('message.unknown_sponsor_id')
        }

        store.dispatch('showToast', {
          title: this.$t('message.error'),
          body: errMessage,
          type: 'error',
          timeout: 5000
        });
      })
    },

    setLanguage(loc) {
      store.commit('setLocale', loc)
    },

    async tryRestorePass() {
      this.isLoading = true;
      store.dispatch('request', {
        path: 'api2/main-app/user/reset-password',
        method: 'post',
        params_: {
          "email": this.email,
          "confirmationUrl": window.location.protocol + "//" + window.location.host + "/?code_confirm={{code}}"
        },
        withoutCheckLogin: true
      }).then((response) => {
            if (response === 'loading') {
              this.isLoading = false;
              store.dispatch('showToast', {
                title: this.$t('message.error'),
                body: this.$t('message.try_to_login'),
                type: 'error',
                timeout: 5000
              });
            } else {
              this.isLoading = false;
              this.currentPage = 0;
              store.dispatch('showToast', {
                title: this.$t('message.recovery_password'),
                body: this.$t('message.check_email'),
                type: 'success',
                timeout: 7000
              });
            }
          }
      ).catch(e => {
        this.errResp = e.response;
        this.isLoading = false;
        store.dispatch('showToast', {
          title: this.$t('message.recovery_password'),
          body: (e && e.response && e.response.data && (typeof e.response.data.errorMessage === 'string')) ? e.response.data.errorMessage : this.$t('message.cant_find_email'),
          type: 'error',
          timeout: 5000
        });

      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '~vuetify/dist/vuetify.min.css';
@import '~bootstrap-vue/dist/bootstrap-vue.min.css';
@import '~bootstrap/dist/css/bootstrap.min.css';
@import "./../../styles/monarch/helpers/animate.css";
@import "./../../styles/monarch/helpers/boilerplate.css";
@import "./../../styles/monarch/helpers/border-radius.css";
@import "./../../styles/monarch/helpers/grid.css";
@import "./../../styles/monarch/helpers/utils.css";
@import "./../../styles/monarch/helpers/colors.css";
@import "./../../styles/monarch/elements/badges.css";
@import "./../../styles/monarch/elements/buttons.css";
@import "./../../styles/monarch/elements/content-box.css";
@import "./../../styles/monarch/elements/dashboard-box.css";
@import "./../../styles/monarch/elements/forms.css";
@import "./../../styles/monarch/elements/responsive-tables.css";
@import "./../../styles/monarch/widgets/modal/modal.css";
@import "./../../styles/monarch/snippets/user-profile.css";
@import "./../../styles/monarch/snippets/mobile-navigation.css";
@import "./../../styles/monarch/applications/mailbox.css";
@import "./../../styles/monarch/themes/admin/layout.css";
@import "./../../styles/monarch/themes/admin/color-schemes/default.css";
@import "./../../styles/monarch/themes/components/default.css";
@import "./../../styles/monarch/themes/components/border-radius.css";
@import "./../../styles/monarch/helpers/responsive-elements.css";
@import "./../../styles/monarch/helpers/admin-responsive.css";
@import "./../../styles/monarch/widgets/touchspin/touchspin.css";
@import "assets/vue_snotify/material.css";
@import "./assets/api2-middleware.css";

.company-logo {
  height:100px;
  background-position: center;
  background-size: contain;
}
</style>
